import React from "react";
import { Camera } from "lucide-react";

const BRAND_GRADIENT = "linear-gradient(135deg,#1480b3 0%,#0d5a80 100%)";

export function PhotosPending({ className = "", compact = false }) {
  return (
    <div
      className={`relative flex items-center justify-center text-center text-white overflow-hidden ${className}`}
      style={{ background: BRAND_GRADIENT }}
      data-testid="photos-pending"
    >
      <div
        className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "radial-gradient(circle at 25% 25%, #fff 1px, transparent 1px)", backgroundSize: "22px 22px" }}
      />
      <div className="relative px-6 py-6">
        <div className={`mx-auto mb-4 flex items-center justify-center rounded-full bg-white/15 backdrop-blur ${compact ? "w-12 h-12" : "w-16 h-16"}`}>
          <Camera className="text-white" size={compact ? 22 : 30} strokeWidth={1.5} />
        </div>
        <p className={`font-heading leading-snug ${compact ? "text-base" : "text-xl sm:text-2xl"}`}>
          Photos en cours de réalisation par un photographe professionnel
        </p>
        {!compact && (
          <p className="mt-2 font-body text-sm text-white/80">
            Reportage photo en cours, photos disponibles prochainement.
          </p>
        )}
      </div>
    </div>
  );
}
